module.exports = __webpack_public_path__ + "img/VL_12_02.db8051e2.png";